export default {
  
  methods: {
    
    draw_Radial(disc=null) {

      let data = disc ? this.rawData.find(f=> f.DISC == disc) : this.rawData.find(f=> f.DISC == 'Overall')

      this.radialCanvas = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.pie.x}, ${this.pie.y})`)
      .attr('font-family', 'roboto')
      .style('cursor', 'default')

      let detail = this.radialCanvas
      .append('g')
      .attr('transform', `translate(0, -8)`)
      .attr('opacity', 1).attr('text-anchor', 'middle')

      detail
      .append('text')
      .attr('id', `DTL_NAME_${this.localId}`)
      .attr('x', 0).attr('y', -20)
      .attr('font-size', 12).attr('fill', '#000')
      .text(data.DISC) // name

      let plan = detail
      .append('g')
      .attr('transform', `translate(-23, 0)`)

      plan
      .append('text').attr('font-size', 9).attr('fill', '#757575').text(`Plan`)

      plan
      .append('text')
      .attr('id', `DTL_PLAN_${this.localId}`)
      .attr('y', 14).attr('font-size', 12).attr('fill', '#333')
      .text(data.PLAN + '%') // Plan

      let actual = detail
      .append('g')
      .attr('transform', `translate(23, 0)`)

      actual
      .append('text').attr('font-size', 9).attr('fill', '#757575').text(`Actual`)

      actual
      .append('text')
      .attr('id', `DTL_ACT_${this.localId}`)
      .attr('y', 14).attr('font-size', 12).attr('fill', '#333')
      .text(data.ACT + '%') // Actual

      this.gmx_Line(detail, -35, 35, -12, -12, '#bcbcbc', .5, .5)
      this.gmx_Line(detail, -40, 40, 20, 20, '#bcbcbc', .5, .5)
      this.gmx_Line(detail, 0, 0, -12, 20, '#bcbcbc', .5, .5)

      let delta = detail
      .append('g')
      .attr('transform', `translate(0, 25)`)

      delta
      .append('text')
      .attr('id', `DTL_DELTA_${this.localId}`)
      .attr('y', 14).attr('font-size', 14).attr('fill', this.gmx_deltaValue(data.DELTA))
      .text(data.DELTA + '%') // Delta

      delta
      .append('text').attr('y', 27).attr('font-size', 9).attr('fill', '#757575').text(`Delta`)

      this.donut_Controller()
    },


    donut_Controller() {
      let pie = this.pie
      let space = 30
      let fa = space/2
      let sRa = this.pie.inRa
      let gap = 1
      let len = null

      let sumBudget = this.rawData.find(f=> f.DISC == 'Overall').BUDGET

      // Grids
      this.draw_Grids(sRa) // -----> draw_RadialChart.js

      this.rawData.filter(f=> f.DISC !== 'Overall').forEach((d, i) => {

        let angle = (360-space) * (d.BUDGET/sumBudget)
        if(i == 0 || i == 1) angle += 1
        if(i == 2 || i == 3) angle += 1.5
        if(i == 43) angle += 5

        let pieArea = this.radialCanvas
        .append('g')
        .attr('transform', `translate(0,0) rotate(${(pie.spin + fa)})`)
        .style('cursor', this.pie.key ? 'pointer' : 'default').attr('opacity', 1)
        .call(this.call_Pie_Event, d)

        // Total
        len = pie.ra
        this.draw_Pie(pieArea, angle, fa, len, sRa, {
          gap:      gap,
          space:    space,
          bColor:   '#E0E0DF', 
          sColor:   '#bcbcbc', 
          sWidth:   .5,
          opacity:  [.1, .5],
          id:       'TOTAL',
          data:     d,
        }) // -----> draw_RadialChart.js

        // Actual
        len = (pie.ra * sRa) + ((pie.ra * (1 - sRa)) * (d.ACT/100))
        this.draw_Pie(pieArea, angle, fa, len, sRa, {
          gap:      gap,
          space:    space,
          bColor:   this.color21[i], 
          sColor:   this.color21[i], 
          sWidth:   1,
          opacity:  [1, 1],
          id:       'ACTUAL',
          data:     d,
        }) // -----> draw_RadialChart.js
        
        fa = fa + angle
      })
    },


    draw_Pie(selection, angle, fa, len, sRa, d) {

      let pie = this.pie
      let aRad = (angle - d.gap) * Math.PI / 180

      selection
      .append('path')
      .attr('id', `PIE_${d.id}_${d.data.DISC}_${this.localId}`)
      .attr('d', `
        M ${pie.ra * sRa} 0 
        L ${len} 0 
        A ${len} ${len} 0 0 1 ${len * Math.cos(aRad)} ${len * Math.sin(aRad)}
        L ${pie.ra * sRa * Math.cos(aRad)} ${pie.ra * sRa * Math.sin(aRad)}
        A ${pie.ra * sRa} ${pie.ra * sRa} 0 0 0 ${pie.ra * sRa} 0
      `)
      .attr('fill', d.bColor).attr('fill-opacity', d.opacity[0]).attr('opacity', 1)
      .attr('stroke', d.sColor).attr('stroke-width', d.sWidth).attr('stroke-opacity', d.opacity[1])
      
      if(d.id == 'ACTUAL') return
      selection
      .append('text')
      .attr('id', `PIE_NAME_${d.data.DISC}_${this.localId}`)
      .attr('transform', `translate(${0}, ${0}) rotate(${angle/2})`)
      .attr('x', this.pie.ra + 5)
      .attr('font-size', this.pie.tSize).attr('fill', this.pie.tColor).attr('opacity', 1)
      .text(d.data.DISC)
    },
    

    draw_Grids(sRa) {
      let ra = this.pie.ra
      let length = ra - (ra * sRa)

      let grids = this.radialCanvas
      .append('g')
      .attr('transform', `translate(0, ${-ra})`)
      .attr('opacity', .7)

      grids
      .append('line')
      .attr('x1', 0).attr('y1', 0).attr('x2', 0).attr('y2', length)
      .attr('stroke', '#bcbcbc').attr('stroke-width', 1)

      for(let i=0; i<=5; i++) {
        grids
        .append('line')
        .attr('x1', -3).attr('y1', (length/5)*i).attr('x2', 3).attr('y2', (length/5)*i)
        .attr('stroke', '#bcbcbc').attr('stroke-width', 1)

        grids
        .append('text')
        .attr('x', 4).attr('y', (length/5)*i +2.5).attr('font-size', 8).attr('fill', '#000')
        .text(`${100 - (i*20)}%`)
      }
    },
  
  }
}